var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  if (!_vm._isMounted) {
    _vm.e0 = function (e) {
      return _vm.$emit("focus")
    }
    _vm.e1 = function (e) {
      return _vm.$emit("blur")
    }
    _vm.e2 = function (e) {
      return _vm.$emit("linechange", e)
    }
    _vm.e3 = function (e) {
      return _vm.$emit("confirm")
    }
    _vm.e4 = function (e) {
      return _vm.$emit("input", e)
    }
    _vm.e5 = function (e) {
      return _vm.$emit("keyboardheightchange")
    }
  }
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }